import { format } from 'date-fns';
import dateFnsLocales from '../helpers/date-fns-locales';

/**
 * Function that parses a specific date to a format ___eee MMM d yyyy h:mm aaaaa___
 * @param date string
 * @param locale string
 */
const getFormattedTime = (date: string, locale: string): string => {
  const dateParse = new Date(date);
  if (!dateParse) {
    return null;
  }
  return format(
    dateParse,
    `eee MMM d yyyy h:mm aaaaa${locale.includes('en') ? "'m'" : ''}`,
    { locale: dateFnsLocales(locale) }
  );
};

export default getFormattedTime;
